import { Select } from "antd";
import { MaterialSymbol, MaterialSymbolProps } from "react-material-symbols";
import { useAppConfig } from "../../Contexts/AppConfigContext";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

interface IconSelectorMultipleProps {
    value?: string[]; // array de IDs seleccionados
    onChange: (ids: string[]) => void;
    optionsSelector: { label: JSX.Element; value: string }[];
    servicesAvailable: { id: string; icon: string; name: any[] }[]; //  recibimos todo
}

const IconSelectorMultiple: React.FC<IconSelectorMultipleProps> = ({
    value = [],
    onChange,
    optionsSelector,
    servicesAvailable
}) => {


    const { t } = useTranslation();
    return (
        <div className="icon-selector">
            <Select
                mode="multiple"
                showSearch
                placeholder={t("components.icon.select-service")}
                value={value}
                onChange={onChange}
                style={{ width: "100%" }}
                options={optionsSelector}
            />

            {/* Vista previa */}
            {value.length > 0 && (
                <div style={{ marginTop: 16, display: "flex", gap: 12, flexWrap: "wrap" }}>
                    {value.map(id => {
                        const service = servicesAvailable.find(s => s.id === id);
                        return service ? (
                            <MaterialSymbol key={id} icon={service.icon as MaterialSymbolProps["icon"]}  variant="outlined" size={32} />
                        ) : null;
                    })}
                </div>
            )}
        </div>
    );
};
export default IconSelectorMultiple;